/**
 * Merge order-derived payment rows with CRM ledger adjustments.
 * Display-only — does not rewrite order sumpaid / Hyp SSOT.
 */

const METHOD_LABELS = {
  credit_card: "אשראי",
  bank_transfer: "העברה בנקאית",
  other: "אחר",
};

function fmtIls(amount) {
  const n = Number(amount);
  if (!Number.isFinite(n)) return "—";
  const abs = Math.abs(n);
  const body = abs.toLocaleString("he-IL", {
    maximumFractionDigits: 2,
    minimumFractionDigits: Number.isInteger(abs) ? 0 : 2,
  });
  const sign = n < 0 ? "−" : "";
  return `${sign}₪${body}`;
}

/**
 * @param {Array<Record<string, unknown>>} autoRows from buildCrmPaymentsReceivedFromOrder
 * @param {Array<Record<string, unknown>>} entries CRM payment-entries (active)
 * @returns {Array<Record<string, unknown>>}
 */
export function mergeCrmPaymentsReceived(autoRows, entries) {
  const list = Array.isArray(autoRows) ? autoRows : [];
  const ledger = Array.isArray(entries) ? entries : [];

  const hideKeys = new Set();
  for (const e of ledger) {
    if (String(e?.entry_kind || "") !== "hide_auto") continue;
    if (e?.cancelled_at) continue;
    const k = String(e?.hides_auto_key || "").trim();
    if (k) hideKeys.add(k);
  }

  const rows = [];

  for (const auto of list) {
    const key = String(auto?.key || "").trim();
    if (key && hideKeys.has(key)) continue;
    rows.push({
      ...auto,
      source: "order",
      source_badge: "מההזמנה",
      cancellable: true,
      cancel_mode: "hide_auto",
      direction: "credit",
      direction_label: "זכות",
      signed_amount_ils: Number(auto?.amount_ils) || 0,
    });
  }

  for (const e of ledger) {
    if (String(e?.entry_kind || "manual") === "hide_auto") continue;
    if (e?.cancelled_at) continue;
    const direction =
      String(e?.direction || "credit").toLowerCase() === "debit"
        ? "debit"
        : "credit";
    const abs = Math.abs(Number(e?.amount_ils) || 0);
    const signed = direction === "debit" ? -abs : abs;
    const method = String(e?.method || "other");
    rows.push({
      key: `manual-${e.id}`,
      entry_id: e.id,
      source: "manual",
      source_badge: "ידני",
      cancellable: true,
      cancel_mode: "cancel_entry",
      method,
      method_label:
        e.method_label || METHOD_LABELS[method] || METHOD_LABELS.other,
      amount_ils: abs,
      signed_amount_ils: signed,
      amount_display: fmtIls(signed),
      direction,
      direction_label: direction === "debit" ? "חובה" : "זכות",
      paid_at: e.entry_date || e.created_at || null,
      note: e.note || null,
      transaction_id: null,
      installments: null,
    });
  }

  return rows;
}

export { METHOD_LABELS as CRM_PAYMENT_METHOD_LABELS, fmtIls as formatCrmPaymentIls };
